import logoColor from '../assets/logos/logo.png';
import '../styles/appBootstrapLoader.css';

export default function AppBootstrapLoader() {
  return (
    <main className="app-bootstrap-loader" aria-busy="true" aria-live="polite">
      <div className="app-bootstrap-loader__content">
        <div className="app-bootstrap-loader__visual" aria-hidden>
          <div className="app-bootstrap-loader__spinner" />
          <img
            src={logoColor}
            alt=""
            className="app-bootstrap-loader__logo"
            width={200}
            height={145}
            decoding="sync"
            fetchPriority="high"
          />
        </div>

        <p className="app-bootstrap-loader__title">
          Chargement en cours
          <span className="app-bootstrap-loader__dots" aria-hidden>
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </main>
  );
}
